import type { OrderFormSchema } from "../schemas";

/**
 * This function is used to merge article ids into an existing order form schema.
 */
export function mergeArticleIds(
	orderFormArticles: OrderFormSchema["articles"],
	mergeableItems: string[] | OrderFormSchema["articles"],
) {
	const current = [...orderFormArticles];

	for (const item of mergeableItems) {
		const articleId = typeof item === "string" ? item : item.articleId;
		if (current.some((article) => article.articleId === articleId)) continue;
		const quantity = typeof item === "string" ? 0 : item.quantity;
		current.push({ articleId, quantity });
	}

	return current;
}
